import { render, staticRenderFns } from "./lab_bookings.vue?vue&type=template&id=ba754a8e&"
import script from "./lab_bookings.vue?vue&type=script&lang=js&"
export * from "./lab_bookings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports